module.exports = __webpack_public_path__ + "img/symbol_5.69510918.png";